<template>
    <div class="d-block">
        <div class="row mx-0">
            <div class="mx-2 my-1" :class="{'ml-0' : key == 0}" v-for="(item, key) in items">
                <order-integration-single-badge  :integration="item"></order-integration-single-badge>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props:{
            order:{
                type: Object,
                required: true
            }
        },
        computed:{
            items(){
                return (this.order && this.order.order_integrations)? this.order.order_integrations : [];
            }
        }
    }
</script>
